module.exports = __webpack_public_path__ + "static/9-89e47d12915f47e990977adc3a8a4374.png";